module.exports = __webpack_public_path__ + "media/images/strategic-partners/medmo-f858acad6840a1ba517dd123de9dc77b.jpeg";